import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function CtaSection() {
  return <section id="cta-section" className="bg-forest py-24 px-6 relative overflow-hidden" data-id="element-11">
      {/* Background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-forest-light opacity-20 blur-3xl rounded-full pointer-events-none" data-id="element-12"></div>

      <div className="max-w-[800px] mx-auto relative z-10 text-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-14">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white leading-tight mb-8" data-id="element-15">
            Prêt à transformer votre espace en{' '}
            <span className="text-accent" data-id="element-16">mine d'or verte</span> ?
          </h2>

          <a href="https://redevenirmoi.com/cart/53664651575664:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block w-full md:w-auto bg-accent hover:bg-accent-light text-forest-dark font-sans font-bold text-xl md:text-2xl py-6 px-10 rounded-xl shadow-[0_0_40px_rgba(233,196,106,0.3)] hover:shadow-[0_0_60px_rgba(233,196,106,0.5)] transition-all duration-300 transform hover:-translate-y-2 border-b-4 border-forest-dark/20 text-center" data-id="element-17">
            OUI, JE VEUX MON PACK RÉCOLTE URBAINE POUR 9.97$
          </a>

          <div className="pt-8 space-y-4 flex flex-col items-center justify-center" data-id="element-18">
            <div className="flex items-center gap-3 text-cream/90 bg-forest-dark/30 py-3 px-6 rounded-lg border border-forest-light/30" data-id="element-19">
              <ShieldCheck className="w-6 h-6 text-accent" data-id="element-20" />
              <p className="font-sans font-medium" data-id="element-21">
                Garantie de satisfaction de 30 jours : Si vous ne récoltez rien,
                vous ne payez rien.
              </p>
            </div>

            <div className="flex items-center gap-2 text-cream/60 text-sm" data-id="element-22">
              <Lock className="w-4 h-4" data-id="element-23" />
              <p className="font-sans" data-id="element-24">
                Paiement sécurisé - Accès immédiat en téléchargement numérique
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}